import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import FeatureMapPage from './pages/FeatureMapPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import MatrixPage from './pages/MatrixPage';
import GuidePage from './pages/GuidePage';
import AskPage from './pages/AskPage';
import ActionsSchedulePage from './pages/ActionsSchedulePage';
import ReleasesPage from './pages/ReleasesPage';
import TelemetryPage from './pages/TelemetryPage';
import SecurityPage from './pages/SecurityPage';
import QualityPage from './pages/QualityPage';
import CompliancePage from './pages/CompliancePage';
import CloudPage from './pages/CloudPage';
import UsagePage from './pages/UsagePage';
import InfraPage from './pages/InfraPage';
import RccsActivityPage from './pages/RccsActivityPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* 홈(로고 클릭) = REDERI 가이드 내용 */}
        <Route index element={<GuidePage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="products/:id" element={<ProductDetailPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        {/* FEAT-015 — /softwares 통합: 제품·SW 단일 화면(/products)으로 리다이렉트 */}
        <Route path="softwares" element={<Navigate to="/products" replace />} />
        <Route path="features" element={<FeatureMapPage />} />
        <Route path="matrix" element={<MatrixPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="quality" element={<QualityPage />} />
        <Route path="compliance" element={<CompliancePage />} />
        <Route path="compliance/activity" element={<RccsActivityPage />} />
        <Route path="cloud" element={<CloudPage />} />
        <Route path="usage" element={<UsagePage />} />
        <Route path="infra" element={<InfraPage />} />
        <Route path="releases" element={<ReleasesPage />} />
        <Route path="actions" element={<ActionsSchedulePage />} />
        <Route path="telemetry" element={<TelemetryPage />} />
        <Route path="ask" element={<AskPage />} />
        {/* 제거된 메뉴 — 기존 링크 호환용 리다이렉트 */}
        <Route path="guide" element={<Navigate to="/" replace />} />
        <Route path="team" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
